import { render, staticRenderFns } from "./BlocosConheca.vue?vue&type=template&id=1fdaea6d&scoped=true"
import script from "./BlocosConheca.vue?vue&type=script&lang=js"
export * from "./BlocosConheca.vue?vue&type=script&lang=js"
import style0 from "./BlocosConheca.vue?vue&type=style&index=0&id=1fdaea6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdaea6d",
  null
  
)

export default component.exports